import type { FaireProductEntity } from "../../entity_types/product";

export const p_4k5tdmn3zz: FaireProductEntity = {
  token: "p_4k5tdmn3zz",
  type: "product",
  name: "Calming Essential Oil Roller",
  brandToken: "b_pt47qddvxc",
  brandName: "Mindful and Co Kids USA",
  imageUrl:
    "https://cdn.faire.com/fastly/b1291d9b9dfa8b4b6ed17c3082ab46a9c83c928867bee0968380bc7b1a7a112f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9b410488376d95478f7dd384c40260c9d46dca2ccd71ac3d9ec874cfebb29e28.png",
    "https://cdn.faire.com/fastly/9d01959a8965d4fe92a52f25ace5c3d3e0400b90aca95f2f801841aa5b960846.png",
    "https://cdn.faire.com/fastly/4c2657052fce7a1b065bb0c889e41e8e426e6419bb620dd1c7c733291e49fb49.png",
  ],
  priceDollars: 8.31,
  description:
    "Bring calm, confidence, and balance into your child’s day with our Calming Essential Oil Roller, a gentle, kid-friendly aromatherapy blend crafted from 100% pure essential oils. Thoughtfully formulated with soothing lavender, uplifting orange, and grounding geranium, this nurturing blend supports emotional regulation, eases anxious feelings, and helps little ones unwind naturally. Perfect for pockets, school bags, bedtime routines, or mindfulness moments, this simple ritual allows children to pause, breathe, and return to calm, whenever and wherever they need it.\n\nDirection:\n- Gently roll onto wrists, behind the ears, temples, or the soles of the feet.\n- Use before bedtime, during transitions, morning routines, or anytime your child needs a soothing moment of peace.\n\n",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:55.028Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
